/**
 * FinancialGraph Component
 * A compact, premium graph with a generated backdrop and glassmorphism overlay.
 */

export function createFinancialGraph(): string {
  const growthImage = '/Users/lloyd.vince1985gmail.com/.gemini/antigravity/brain/043dd786-8487-40b8-99b3-e469d7d57475/arceus_growth_index_premium_1773409934046.png';

  return `
    <div class="financial-graph-container" style="
      position:relative; 
      width:100%; 
      height:240px; 
      background:#000; 
      border-radius:12px; 
      border:1px solid rgba(201, 162, 39, 0.15); 
      overflow:hidden;
      box-shadow: 0 20px 40px rgba(0,0,0,0.4);
    ">
      
      <!-- Generated Backdrop Image -->
      <img src="${growthImage}" alt="" style="
        position:absolute; 
        inset:0; 
        width:100%; 
        height:100%; 
        object-fit:cover; 
        opacity:0.6;
        filter: brightness(0.8) contrast(1.1);
      ">

      <!-- Glassmorphism Overlay -->
      <div style="
        position:absolute; 
        inset:0; 
        background: radial-gradient(circle at 30% 30%, rgba(201,162,39,0.05) 0%, transparent 60%);
        backdrop-filter: blur(2px);
        z-index:1;
      "></div>

      <svg width="100%" height="100%" viewBox="0 0 800 240" preserveAspectRatio="none" style="display:block; position:relative; z-index:2;">
        <defs>
          <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" style="stop-color:#C9A227; stop-opacity:0" />
            <stop offset="50%" style="stop-color:#C9A227; stop-opacity:1" />
            <stop offset="100%" style="stop-color:#C9A227; stop-opacity:0.7" />
          </linearGradient>
          <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="3" result="blur" />
            <feComposite in="SourceGraphic" in2="blur" operator="over" />
          </filter>
        </defs>

        <!-- Ultra-minimalist Main Line -->
        <path d="M0 200 Q 150 180, 300 140 T 500 100 T 800 20"
          fill="none"
          stroke="url(#lineGradient)"
          stroke-width="2"
          filter="url(#glow)"
          stroke-linecap="round"
          style="opacity:0.9;" />

        <!-- Accent Data Points -->
        <circle cx="300" cy="140" r="3" fill="#C9A227" style="opacity:0.8;" />
        <circle cx="500" cy="100" r="3" fill="#C9A227" style="opacity:0.8;" />
        <circle cx="800" cy="20" r="3" fill="#C9A227" style="opacity:0.8;" />
      </svg>

      <!-- Minimal Labels -->
      <div style="
        position:absolute; 
        top:20px; 
        left:20px; 
        font-family:'Inter',sans-serif; 
        font-size:10px; 
        font-weight:600;
        color:#C9A227; 
        text-transform:uppercase; 
        letter-spacing:0.2em; 
        z-index:3;
        text-shadow: 0 2px 4px rgba(0,0,0,0.5);
      ">
        Strategic Growth Index
      </div>
    </div>
  `;
}

export default createFinancialGraph;
